const { map } = require('lodash'), { createBundleTiles } = require('../tiles/product-tile-factory');

class ConveniencePackTileListController {
    constructor(settings, trolleyService, productGroupService) {
        this.settings = settings;
        this.trolleyService = trolleyService;
        this.productGroupService = productGroupService;
    }

    $onInit() {
        this.sortOptions = this.productGroupService.getSortOptions();
    }

    createTiles(bundles) {
        return {
            items: createBundleTiles(bundles.items),
            totalRecordCount: bundles.totalRecordCount,
        };
    }

    getTiles(pageSize, pageNumber, sortType = 'Name') {
        return this.productGroupService.selectProductGroup(this.packId)
            .then(() => this.productGroupService.getProducts({ pageNumber, pageSize, sortType }))
            .then(bundles => this.createTiles(bundles));
    }

    addAll() {
        this.productGroupService.getProducts({ pageNumber: 0, pageSize: this.productGroupService.selectedGroupTotalCount, sortType: 'Name' }).then((response) => {
            this.trolleyService.addItemsToTrolley(map(response.items, item => item.Products[0]));
        });
    }
}

ConveniencePackTileListController.$inject = ['Settings', 'TrolleyService', 'ProductGroupService'];

const conveniencePackTileListComponentDefinition = {
    bindings: {
        packId: '<',
        pageNumber: '<',
        sortBy: '<',
    },
    controller: ConveniencePackTileListController,
    template: `
        <wow-tile-list
            list-title="$ctrl.productGroupService.selectedGroup.Name"
            page-number="$ctrl.pageNumber"
            sort-by="$ctrl.sortBy"
            sort-options="::$ctrl.sortOptions"
            get-tiles="$ctrl.getTiles(pageSize, pageNumber, sortType)">

            <top-right>
                <button class="button button--primary" ng-click="$ctrl.addAll()">
                    Add all ({{ $ctrl.productGroupService.selectedGroupTotalCount }})
                </button>
            </top-right>
        </wow-tile-list>
    `,
};

module.exports = {
    ConveniencePackTileListController,
    conveniencePackTileListComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/partner/convenience-pack-tile-list.component.js